import { z } from 'zod';

export const privacySettingsSchema = z.object({
  email: z.boolean(),
  push_notifications: z.boolean(),
  tracking: z.boolean(),
})

export type PrivacySettings = z.infer<typeof privacySettingsSchema>;

